import {createSelector} from 'reselect';
import {getSettings} from './selectors';

export default createSelector(
  [getSettings],
  settings => !!settings?.should_validate_country_code_on_place_order,
);
